import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so the catalog and product pages share a single fetch.
let _cache = null;
let _inflight = null;

function buildIndex(entries) {
  const byProduct = {};
  const bySlug = {};
  (entries || []).forEach((e) => {
    if (e.productId) byProduct[e.productId] = e;
    if (e.slug) bySlug[e.slug] = e;
  });
  return { byProduct, bySlug, entries: entries || [] };
}

async function fetchIndex() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/research`)
    .then(({ data }) => {
      _cache = buildIndex(data);
      return _cache;
    })
    .catch(() => buildIndex([]))
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

/**
 * Shared research-library index. Returns { byProduct, bySlug, entries }.
 * byProduct is keyed by product id; each value is the full library entry
 * (including `slug` and `identityVerified`).
 */
export function useResearchIndex() {
  const [index, setIndex] = useState(_cache || { byProduct: {}, bySlug: {}, entries: [] });

  useEffect(() => {
    let alive = true;
    fetchIndex().then((idx) => {
      if (alive) setIndex(idx);
    });
    return () => {
      alive = false;
    };
  }, []);

  return index;
}
